import { format } from "date-fns";

export type CsvField = string | number | boolean | null | undefined;

export const CSV_EMPTY = "--";

export const toEnabledDisabled = (value: boolean): string => (value ? "Enabled" : "Disabled");

export const displayOrDash = (value: string | null | undefined): string => value || CSV_EMPTY;

export const quoteCsvField = (value: CsvField): string => {
  const raw = value == null ? "" : String(value);
  return `"${raw.replace(/"/g, '""')}"`;
};

export const toCsv = (headers: readonly string[], rows: readonly CsvField[][]): string => {
  const lines = [headers.join(",")];
  for (const row of rows) {
    lines.push(row.map(quoteCsvField).join(","));
  }
  return lines.join("\n");
};

export const generateTimestampedCsvFilename = (
  prefix: string,
  now: Date = new Date(),
): string => `${prefix}_${format(now, "yyyy-MM-dd_HH_mm_ss")}.csv`;

export const downloadCSV = (csvContent: string, filename: string): void => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
